import React, { useState, useEffect, useCallback } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { RefreshCw, AlertCircle, Download, FileText, X, Filter } from 'lucide-react';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// ============================================================================
// CHAMPION: PRODUCTION VS SALES DASHBOARD - SP26 DIV 10
// Compares Production (receipts + WIP) with Sales (orderfile)
// Filtered by Program = CHAMPION, open to all customers
// ============================================================================

// Champion script logo SVG paths (without white background)
const CHAMPION_LOGO_PATHS = [
  // Script "Champion" text
  "M59.093 76.905c-.65 4.364-1.949 14.947.835 25.438.557 1.393 1.95 1.021 2.506.371.186-.278 2.043-2.042 2.043-2.042.649-.929 1.3-.65 1.764 0 .464.649 1.764 2.692 3.714 2.785 1.949.093 5.013-2.229 6.22-3.156.835 1.578 1.856 3.063 3.528 2.971 1.671-.094 3.249-1.3 4.642-2.785 1.021 1.207 2.135 2.506 3.435 2.414 1.3-.094 3.713-1.486 6.034-3.621.929-1.021 1.95-.557 2.6.464.649 1.021 1.579 2.692 2.786 2.692 1.205 0 2.971-1.671 3.527-2.135.557-.465 1.113-.836 1.764-.094l1.393 1.3c.836.836 2.6.65 3.898-.557 1.301-1.207 1.578-1.578 2.137-1.578.557 0 .834.743 1.391 1.3.559.557 4.828 4.271 10.492-1.485.092 2.878-.559 19.031-.559 21.353 0 1.113 1.301 1.485 3.158 1.113 1.855-.371 2.785-.928 2.691-3.62s-.465-15.968-.465-15.968c.279-2.136 2.135-5.663 4.086-5.756 1.949-.094 1.021 2.32.092 2.32-.928 0-1.949.465-1.949 1.3 0 .836.279 3.249 5.756 3.249s6.127-1.764 7.613-2.413c.928 1.764 3.713 4.549 11.418-.372 1.578 1.857 4.549 4.178 7.799 1.857 1.021-.836 2.041-2.785 1.67-4.456-.277-.65-.092-.929.371-.929h3.064c.65 0 1.764.464 2.135 2.321.373 1.856 1.672 3.435 2.693 3.342s2.971-1.671 4.084-2.785c.93 1.3 4.92 7.334 12.254-2.785.65-.928-.371-1.393-.928-.743s-2.229 1.672-3.621 1.765-3.062-1.3-4.363-3.063c-1.299-1.764-2.785-1.114-3.713.278-.65.743-1.021 1.485-1.764 2.321-.465-.836-1.021-2.6-1.949-3.25-.93-.65-1.672-.743-3.9-.186-2.227.558-4.734.836-7.24.929-1.393-.093-1.021.557-.928 1.114.092.557 1.113 2.878-.744 2.971-1.855.093-1.67-2.692-.371-4.178.65-.65-.277-2.042-1.299-1.485-1.021.557-1.672.835-2.508 2.135-.834 1.3-2.598 3.249-5.477 3.343-2.879.093-2.043-3.25-1.949-4.735 0-.835-.557-1.578-2.043-1.207-1.484.372-3.436.186-3.25 4.27-1.02 1.486-3.342 2.414-5.197 2.136-.559-.093-.744-.371-.559-1.021.188-.649.65-4.271-2.135-5.198-2.785-.929-4.92.371-6.312 1.578-.742.371-.928 0-.928-.65l.092-3.435c0-1.578-3.156-1.949-3.619-.093-.465 1.856-1.021 5.478-3.807 6.776-2.785 1.3-3.715-.371-5.199-2.228-1.486-1.857-2.971-1.764-4.643-.093l-1.67 1.578c-.65.557-1.021.371-1.578-.464-.559-.836-.93-1.95-1.951-2.043-1.02-.093-1.205.279-1.949.836l-2.135 1.671c-.836.649-1.021.649-1.857-.464 0 0-1.393-2.321-2.785-2.321-1.391 0-1.856.836-2.691 1.485 0 0-2.136 1.485-2.878 2.135-.743.65-2.878 1.95-4.92-1.113-.743-1.114-2.042-1.95-2.971-.372-.928 1.579-2.414 3.992-3.528 3.25-1.114-.743.743-2.878 2.135-3.063 1.393-.186.557-1.95-.835-2.043-1.393-.093-3.621.836-4.642 2.043-1.021 1.206-2.692 2.6-4.363 2.506-1.671-.093-2.042-1.393-2.878-3.156s-2.321-1.578-3.435-.649c-1.114.928-1.393 1.207-2.228 2.228-.835 1.021-.835.465-.928-.186s-.65-12.625.278-20.331c.371-1.951-3.621-2.601-4.457.369z",
  // Circle dot
  "M146.916 91.213a2.888 2.888 0 1 0 .001-5.777 2.888 2.888 0 0 0-.001 5.777z",
  // "C" mark
  "M54.452 94.173c-.372.279-10.862 3.807-16.618 4.178V76.813c3.342.092 9.655 1.485 13.647 2.971.928.464 2.877-.093.835-2.135-4.735-3.806-12.162-6.685-22.002-6.685s-27.48 5.477-27.48 16.618 14.111 16.71 27.572 16.71c9.47 0 18.289-3.435 24.695-9.562 1.022-1.021-.278-.835-.649-.557zm-31.845 4.162c-8.013-1.65-13.694-5.801-13.694-10.66 0-4.857 5.686-9.007 13.694-10.658v21.318z",
];

// Helper: convert SVG string to PNG data URL for PDF embedding
const championLogoToDataUrl = () => {
  return new Promise((resolve) => {
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 65 193 45"><g fill="#002244" fill-rule="evenodd" clip-rule="evenodd">${CHAMPION_LOGO_PATHS.map(d => `<path d="${d}"/>`).join('')}</g></svg>`;
    const canvas = document.createElement('canvas');
    canvas.width = 400;
    canvas.height = 94;
    const ctx = canvas.getContext('2d');
    const img = new Image();
    const blob = new Blob([svgString], { type: 'image/svg+xml' });
    const url = URL.createObjectURL(blob);
    img.onload = () => {
      ctx.drawImage(img, 0, 0, 400, 94);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
};

export default function ChampionProductionSalesDashboard() {
  // Data state
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [customerData, setCustomerData] = useState([]);
  const [labelData, setLabelData] = useState([]);
  const [countryOriginData, setCountryOriginData] = useState([]);

  // Locked filters - Champion SP26 Div 10
  const selectedSeason = 'SP26';

  // Excluded labels (clicking a label excludes it) - purely data-driven
  const [excludedLabels, setExcludedLabels] = useState([]);
  // Exclude All Year Styles filter
  const [excludeAllYear, setExcludeAllYear] = useState(true);


  // Format currency
  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === 0) return '$0';
    const num = Number(value) || 0;
    if (Math.abs(num) >= 1000000) {
      return `$${(num / 1000000).toFixed(2)}M`;
    }
    if (Math.abs(num) >= 1000) {
      return `$${(num / 1000).toFixed(1)}K`;
    }
    return `$${num.toFixed(0)}`;
  };

  // Format number with commas
  const formatNumber = (value) => {
    if (value === null || value === undefined || value === 0) return '0';
    return Number(value).toLocaleString();
  };

  // Format percentage (GP%)
  const formatPct = (value) => {
    if (value === null || value === undefined) return '-';
    return `${(Number(value) * 100).toFixed(1)}%`;
  };

  // Calculate GP%
  const calcGP = (revenue, cost) => {
    if (!revenue || revenue === 0) return 0;
    return (revenue - cost) / revenue;
  };

  // Fetch all data
  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const functions = getFunctions();
      const getProductionSalesData = httpsCallable(functions, 'getProductionSalesData', { timeout: 150000 });

      // Build filter params - locked to Champion program, SP26, Division 10
      const filterParams = {
        seasons: [selectedSeason],
        divisions: ['10'],
        filterPrograms: ['CHAMPION'],
        excludeLabels: excludedLabels.length > 0 ? excludedLabels : null,
        excludeAllYear: excludeAllYear,
      };

      const [customerResult, labelResult, countryOriginResult] = await Promise.all([
        getProductionSalesData({ ...filterParams, groupBy: 'Customer' }),
        getProductionSalesData({ ...filterParams, groupBy: 'Label' }),
        getProductionSalesData({ ...filterParams, groupBy: 'CountryOriginType' }),
      ]);

      setCustomerData(customerResult.data.summary || []);
      setLabelData(labelResult.data.summary || []);
      setCountryOriginData(countryOriginResult.data.summary || []);

    } catch (err) {
      console.error('Error fetching Champion Production vs Sales data:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [excludedLabels, excludeAllYear]);

  // Load data on mount and when filters change
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Toggle label exclusion (clicking excludes/includes)
  const toggleLabelExclusion = (label) => {
    setExcludedLabels(prev =>
      prev.includes(label)
        ? prev.filter(l => l !== label)
        : [...prev, label]
    );
  };

  // Toggle cross-filter selections
  // Clear filters
  const clearFilters = () => {
    setExcludedLabels([]);
    setExcludeAllYear(false);
  };

  const hasActiveFilters = excludedLabels.length > 0 || excludeAllYear;

  // Get unique labels from label data for the filter UI (data-driven)
  const availableLabels = labelData.map(row => row.Label || '(No Label)');

  // Export to Excel
  const handleExportExcel = () => {
    const wb = XLSX.utils.book_new();

    const mapRow = (row, groupField) => {
      const totalProdRev = Number(row.Total_Production_Revenue) || 0;
      const totalProdCost = Number(row.Total_Production_Cost) || 0;
      const invoicedRev = Number(row.Invoiced_Revenue) || 0;
      const invoicedCost = Number(row.Invoiced_Cost) || 0;
      const leftToShipRev = totalProdRev - invoicedRev;
      const leftToShipCost = totalProdCost - invoicedCost;
      const onPickRev = Number(row.On_Pick_Revenue) || 0;
      const onPickCost = Number(row.On_Pick_Cost) || 0;
      const receivedRev = Number(row.Received_Revenue) || 0;
      const receivedCost = Number(row.Received_Cost) || 0;
      const atsRev = receivedRev - invoicedRev - onPickRev;
      const atsCost = receivedCost - invoicedCost - onPickCost;

      return {
        [groupField]: row[groupField],
        'Total Prod $': totalProdRev,
        'Total Cost': totalProdCost,
        'Total Prod GP%': calcGP(totalProdRev, totalProdCost),
        'Invoice $': invoicedRev,
        'Invoice GP%': calcGP(invoicedRev, invoicedCost),
        'Left to Ship $': leftToShipRev,
        'LTS Cost': leftToShipCost,
        'LTS GP%': calcGP(leftToShipRev, leftToShipCost),
        'On Pick $': onPickRev,
        'On Pick GP%': calcGP(onPickRev, onPickCost),
        'ATS $': atsRev,
        'ATS Cost': atsCost,
        'ATS GP%': calcGP(Math.abs(atsRev), Math.abs(atsCost)),
      };
    };

    if (presoldData.length > 0) {
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(presoldData.map(r => mapRow(r, 'Customer'))), 'Presold');
    }
    if (openStockData.length > 0) {
      XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(openStockData.map(r => mapRow(r, 'Customer'))), 'Open Stock');
    }

    XLSX.writeFile(wb, `Champion_ProductionVsSales_${selectedSeason}_${new Date().toISOString().split('T')[0]}.xlsx`);
  };

  // Export to PDF
  const handleExportPDF = async () => {
    const doc = new jsPDF('landscape');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    // Champion script logo
    const logoDataUrl = await championLogoToDataUrl();
    if (logoDataUrl) {
      doc.addImage(logoDataUrl, 'PNG', 10, 4, 55, 13);
    }
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(12);
    doc.setTextColor(0, 34, 68);
    doc.text(`Production vs Sales - ${selectedSeason} Div 10`, 68, 14);
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text('Excludes All Year Seasons', 14, 21);
    doc.setTextColor(150, 150, 150);
    doc.text(`Generated: ${new Date().toLocaleString()}`, 14, 26);

    // Summary Cards Row
    const cardY = 31;
    const cardH = 18;
    const cardGap = 3;
    const cardW = (pageWidth - 28 - cardGap * 5) / 6;
    const cards = [
      { label: 'Total Production', value: formatCurrency(summary.totalProdRev), gp: formatPct(summary.totalProdGP), bg: [219, 225, 254] },
      { label: 'Invoice', value: formatCurrency(summary.invoicedRev), gp: formatPct(summary.invoicedGP), bg: [220, 252, 231] },
      { label: 'Left to Ship', value: formatCurrency(summary.totalProdRev - summary.invoicedRev), gp: formatPct(calcGP(summary.totalProdRev - summary.invoicedRev, summary.totalProdCost - summary.invoicedCost)), bg: [243, 232, 255] },
      { label: 'On Pick', value: formatCurrency(summary.onPickRev), gp: formatPct(summary.onPickGP), bg: [255, 237, 213] },
      { label: 'ATS', value: formatCurrency(summary.atsRev), gp: formatPct(summary.atsGP), bg: [204, 251, 241] },
      { label: 'Total WIP', value: formatCurrency(summary.inTransitRev + summary.wipNotTransitRev), gp: formatPct(calcGP(summary.inTransitRev + summary.wipNotTransitRev, summary.inTransitCost + summary.wipNotTransitCost)), bg: [255, 251, 235] },
    ];

    cards.forEach((card, i) => {
      const x = 14 + i * (cardW + cardGap);
      doc.setFillColor(...card.bg);
      doc.roundedRect(x, cardY, cardW, cardH, 2, 2, 'F');
      doc.setFontSize(7);
      doc.setTextColor(80, 80, 80);
      doc.text(card.label, x + cardW / 2, cardY + 5, { align: 'center' });
      doc.setFontSize(12);
      doc.setTextColor(30, 30, 30);
      doc.text(card.value, x + cardW / 2, cardY + 11, { align: 'center' });
      doc.setFontSize(7);
      doc.setTextColor(100, 100, 100);
      doc.text(`${card.gp} GP`, x + cardW / 2, cardY + 15, { align: 'center' });
    });

    const tableMargin = 14;
    const headers = (groupLabel) => [[groupLabel, 'Total Cost (Landed)', 'Total Prod $', 'GP%', 'Invoice $', 'GP%', 'LTS Cost (Landed)', 'Left to Ship $', 'GP%', 'On Pick $', 'GP%', 'ATS Cost (Landed)', 'ATS $', 'GP%']];

    const mapPdfRow = (row, groupField) => {
      const totalProdRev = Number(row.Total_Production_Revenue) || 0;
      const totalProdCost = Number(row.Total_Production_Cost) || 0;
      const invoicedRev = Number(row.Invoiced_Revenue) || 0;
      const invoicedCost = Number(row.Invoiced_Cost) || 0;
      const leftToShipRev = totalProdRev - invoicedRev;
      const leftToShipCost = totalProdCost - invoicedCost;
      const onPickRev = Number(row.On_Pick_Revenue) || 0;
      const onPickCost = Number(row.On_Pick_Cost) || 0;
      const receivedRev = Number(row.Received_Revenue) || 0;
      const receivedCost = Number(row.Received_Cost) || 0;
      const atsRev = receivedRev - invoicedRev - onPickRev;
      const atsCost = receivedCost - invoicedCost - onPickCost;
      return [
        row[groupField] || '-',
        formatCurrency(totalProdCost), formatCurrency(totalProdRev), formatPct(calcGP(totalProdRev, totalProdCost)),
        formatCurrency(invoicedRev), formatPct(calcGP(invoicedRev, invoicedCost)),
        formatCurrency(leftToShipCost), formatCurrency(leftToShipRev), formatPct(calcGP(leftToShipRev, leftToShipCost)),
        formatCurrency(onPickRev), formatPct(calcGP(onPickRev, onPickCost)),
        formatCurrency(atsCost), formatCurrency(atsRev), formatPct(calcGP(Math.abs(atsRev), Math.abs(atsCost))),
      ];
    };

    const calcTotalsForPdf = (data) => data.reduce((acc, row) => {
      const tp = Number(row.Total_Production_Revenue) || 0;
      const tc = Number(row.Total_Production_Cost) || 0;
      const ir = Number(row.Invoiced_Revenue) || 0;
      const ic = Number(row.Invoiced_Cost) || 0;
      const opr = Number(row.On_Pick_Revenue) || 0;
      const opc = Number(row.On_Pick_Cost) || 0;
      const rcvr = Number(row.Received_Revenue) || 0;
      const rcvc = Number(row.Received_Cost) || 0;
      return {
        tpRev: acc.tpRev + tp, tpCost: acc.tpCost + tc,
        invRev: acc.invRev + ir, invCost: acc.invCost + ic,
        ltsRev: acc.ltsRev + (tp - ir), ltsCost: acc.ltsCost + (tc - ic),
        opRev: acc.opRev + opr, opCost: acc.opCost + opc,
        rcvRev: acc.rcvRev + rcvr, rcvCost: acc.rcvCost + rcvc,
      };
    }, { tpRev: 0, tpCost: 0, invRev: 0, invCost: 0, ltsRev: 0, ltsCost: 0, opRev: 0, opCost: 0, rcvRev: 0, rcvCost: 0 });

    const buildTotalRow = (totals) => [
      'TOTAL',
      formatCurrency(totals.tpCost), formatCurrency(totals.tpRev), formatPct(calcGP(totals.tpRev, totals.tpCost)),
      formatCurrency(totals.invRev), formatPct(calcGP(totals.invRev, totals.invCost)),
      formatCurrency(totals.ltsCost), formatCurrency(totals.ltsRev), formatPct(calcGP(totals.ltsRev, totals.ltsCost)),
      formatCurrency(totals.opRev), formatPct(calcGP(totals.opRev, totals.opCost)),
      formatCurrency(totals.rcvCost - totals.invCost - totals.opCost), formatCurrency(totals.rcvRev - totals.invRev - totals.opRev), formatPct(calcGP(Math.abs(totals.rcvRev - totals.invRev - totals.opRev), Math.abs(totals.rcvCost - totals.invCost - totals.opCost))),
    ];

    const tableStyles = {
      theme: 'grid',
      margin: { left: tableMargin, right: tableMargin },
      styles: { fontSize: 7, cellPadding: 2, lineColor: [147, 161, 219], lineWidth: 0.3 },
      headStyles: { fillColor: [0, 61, 165], textColor: 255, fontSize: 7, lineColor: [0, 61, 165] },
      alternateRowStyles: { fillColor: [240, 243, 255] },
      columnStyles: {
        0: { cellWidth: 35 },
        1: { halign: 'right' }, 2: { halign: 'right' },
        3: { halign: 'right' }, 4: { halign: 'right' },
        5: { halign: 'right' }, 6: { halign: 'right' },
        7: { halign: 'right' }, 8: { halign: 'right' },
        9: { halign: 'right' }, 10: { halign: 'right' },
      },
    };

    const drawTable = (tableData, startY, rowCount) => {
      autoTable(doc, {
        ...tableStyles,
        startY,
        head: tableData.head,
        body: tableData.body,
        didParseCell: (data) => {
          if (data.row.index === rowCount && data.section === 'body') {
            data.cell.styles.fontStyle = 'bold';
            data.cell.styles.fillColor = [226, 232, 240];
          }
        },
      });
      return doc.lastAutoTable.finalY;
    };

    // Presold Table
    let tableStartY = cardY + cardH + 8;
    doc.setFontSize(11);
    doc.setTextColor(30, 30, 30);
    doc.text('Presold', 14, tableStartY);

    const presoldTotals = calcTotalsForPdf(presoldData);
    let lastY = drawTable({
      head: headers('Customer'),
      body: [...presoldData.map(r => mapPdfRow(r, 'Customer')), buildTotalRow(presoldTotals)],
    }, tableStartY + 4, presoldData.length);

    // Open Stock Table - same page
    if (openStockData.length > 0) {
      const openY = lastY + 6;
      doc.setFontSize(11);
      doc.setTextColor(30, 30, 30);
      doc.text('Open Stock', 14, openY);

      const openStockTotals = calcTotalsForPdf(openStockData);
      drawTable({
        head: headers('Customer'),
        body: [...openStockData.map(r => mapPdfRow(r, 'Customer')), buildTotalRow(openStockTotals)],
      }, openY + 4, openStockData.length);
    }

    // Footer: development mode note
    doc.setFontSize(7);
    doc.setTextColor(180, 180, 180);
    doc.text('This report is still in development mode', pageWidth - 14, pageHeight - 8, { align: 'right' });

    doc.save(`Champion_ProductionVsSales_${selectedSeason}_${new Date().toISOString().split('T')[0]}.pdf`);
  };

  // Data Table Component with cross-filter support - Shows $ and GP% only
  const DataTable = ({ title, data, groupByField, icon: Icon, color = 'slate', selectedItems = [], onItemClick }) => {
    // Calculate totals for footer
    const calcTotals = data.reduce((acc, row) => {
      const totalProdRev = Number(row.Total_Production_Revenue) || 0;
      const totalProdCost = Number(row.Total_Production_Cost) || 0;
      const invoicedRev = Number(row.Invoiced_Revenue) || 0;
      const invoicedCost = Number(row.Invoiced_Cost) || 0;
      const leftToShipRev = totalProdRev - invoicedRev;
      const leftToShipCost = totalProdCost - invoicedCost;
      return {
        totalProdRev: acc.totalProdRev + totalProdRev,
        totalProdCost: acc.totalProdCost + totalProdCost,
        invoicedRev: acc.invoicedRev + invoicedRev,
        invoicedCost: acc.invoicedCost + invoicedCost,
        leftToShipRev: acc.leftToShipRev + leftToShipRev,
        leftToShipCost: acc.leftToShipCost + leftToShipCost,
        onPickRev: acc.onPickRev + (Number(row.On_Pick_Revenue) || 0),
        onPickCost: acc.onPickCost + (Number(row.On_Pick_Cost) || 0),
        receivedRev: acc.receivedRev + (Number(row.Received_Revenue) || 0),
        receivedCost: acc.receivedCost + (Number(row.Received_Cost) || 0),
      };
    }, { totalProdRev: 0, totalProdCost: 0, invoicedRev: 0, invoicedCost: 0, leftToShipRev: 0, leftToShipCost: 0, onPickRev: 0, onPickCost: 0, receivedRev: 0, receivedCost: 0 });

    const hasSelection = selectedItems.length > 0;
    const gpColorClass = (gp) => gp >= 0.3 ? 'text-green-600' : gp < 0 ? 'text-red-600' : 'text-slate-500';

    return (
      <div className={`bg-white rounded-lg border overflow-hidden shadow-sm mb-4 ${hasSelection ? 'border-indigo-300 ring-1 ring-indigo-200' : 'border-slate-200'}`}>
        {/* Header */}
        <div className={`px-4 py-2.5 border-b border-slate-100 bg-gradient-to-r from-${color}-50 to-white flex items-center justify-between`}>
          <div className="flex items-center gap-2">
            <div className={`w-6 h-6 rounded-md bg-${color}-100 flex items-center justify-center`}>
              {Icon && <Icon size={12} className={`text-${color}-600`} />}
            </div>
            <div>
              <h3 className="text-xs font-semibold text-slate-800">{title}</h3>
              <p className="text-[10px] text-slate-400">
                {data.length} rows {hasSelection && <span className="text-indigo-600 font-medium">• {selectedItems.length} selected</span>}
              </p>
            </div>
          </div>
          <span className="text-[10px] text-slate-400 italic">Click row to filter</span>
        </div>

        {/* Table */}
        <div className="overflow-x-auto" style={{ maxHeight: '280px' }}>
          <table className="w-full text-xs">
            <thead className="sticky top-0 bg-slate-50 z-10">
              <tr>
                <th className="px-3 py-2 text-left font-semibold text-slate-600 border-b border-slate-200 whitespace-nowrap">{groupByField.replace('_', ' ')}</th>
                <th className="px-2 py-2 text-right font-semibold text-blue-500 border-b border-slate-200 bg-blue-50/30">Cost <span className="text-[9px] font-normal opacity-60">(Landed)</span></th>
                <th className="px-2 py-2 text-right font-semibold text-indigo-600 border-b border-slate-200 bg-indigo-50/50">Total Prod $</th>
                <th className="px-2 py-2 text-right font-semibold text-indigo-600 border-b border-slate-200 bg-indigo-50/50">GP%</th>
                <th className="px-2 py-2 text-right font-semibold text-green-600 border-b border-slate-200 bg-green-50/50">Invoice $</th>
                <th className="px-2 py-2 text-right font-semibold text-green-600 border-b border-slate-200 bg-green-50/50">GP%</th>
                <th className="px-2 py-2 text-right font-semibold text-purple-500 border-b border-slate-200 bg-purple-50/30">LTS <span className="text-[9px] font-normal opacity-60">(Landed)</span></th>
                <th className="px-2 py-2 text-right font-semibold text-purple-600 border-b border-slate-200 bg-purple-50/50">Left to Ship $</th>
                <th className="px-2 py-2 text-right font-semibold text-purple-600 border-b border-slate-200 bg-purple-50/50">GP%</th>
                <th className="px-2 py-2 text-right font-semibold text-orange-600 border-b border-slate-200 bg-orange-50/50">On Pick $</th>
                <th className="px-2 py-2 text-right font-semibold text-orange-600 border-b border-slate-200 bg-orange-50/50">GP%</th>
                <th className="px-2 py-2 text-right font-semibold text-teal-500 border-b border-slate-200 bg-teal-50/30">ATS Cost <span className="text-[9px] font-normal opacity-60">(Landed)</span></th>
                <th className="px-2 py-2 text-right font-semibold text-teal-600 border-b border-slate-200 bg-teal-50/50">ATS $</th>
                <th className="px-2 py-2 text-right font-semibold text-teal-600 border-b border-slate-200 bg-teal-50/50">GP%</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => {
                const itemValue = row[groupByField];
                const isSelected = selectedItems.includes(itemValue);
                const totalProdRev = Number(row.Total_Production_Revenue) || 0;
                const totalProdCost = Number(row.Total_Production_Cost) || 0;
                const invoicedRev = Number(row.Invoiced_Revenue) || 0;
                const invoicedCost = Number(row.Invoiced_Cost) || 0;
                const leftToShipRev = totalProdRev - invoicedRev;
                const leftToShipCost = totalProdCost - invoicedCost;
                const onPickRev = Number(row.On_Pick_Revenue) || 0;
                const onPickCost = Number(row.On_Pick_Cost) || 0;
                const openConfRev = Number(row.Open_Confirmed_Revenue) || 0;
                const openConfCost = Number(row.Open_Confirmed_Cost) || 0;
                const receivedRev = Number(row.Received_Revenue) || 0;
                const receivedCost = Number(row.Received_Cost) || 0;
                const atsRev = receivedRev - invoicedRev - onPickRev;
                const atsCost = receivedCost - invoicedCost - onPickCost;

                return (
                  <tr
                    key={idx}
                    onClick={() => onItemClick && onItemClick(itemValue)}
                    className={`border-b border-slate-100 transition-colors cursor-pointer ${
                      isSelected
                        ? 'bg-indigo-100 hover:bg-indigo-150 border-l-4 border-l-indigo-500'
                        : 'hover:bg-slate-50'
                    }`}
                  >
                    <td className={`px-3 py-2 font-medium truncate max-w-[160px] ${isSelected ? 'text-indigo-700' : 'text-slate-700'}`}>
                      {itemValue || '-'}
                    </td>
                    <td className="px-2 py-2 text-right tabular-nums text-blue-500">{formatCurrency(totalProdCost)}</td>
                    <td className="px-2 py-2 text-right tabular-nums font-medium text-indigo-700">{formatCurrency(totalProdRev)}</td>
                    <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(totalProdRev, totalProdCost))}`}>{formatPct(calcGP(totalProdRev, totalProdCost))}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-green-700">{formatCurrency(invoicedRev)}</td>
                    <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(invoicedRev, invoicedCost))}`}>{formatPct(calcGP(invoicedRev, invoicedCost))}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-purple-500">{formatCurrency(leftToShipCost)}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-purple-700">{formatCurrency(leftToShipRev)}</td>
                    <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(leftToShipRev, leftToShipCost))}`}>{formatPct(calcGP(leftToShipRev, leftToShipCost))}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-orange-700">{formatCurrency(onPickRev)}</td>
                    <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(onPickRev, onPickCost))}`}>{formatPct(calcGP(onPickRev, onPickCost))}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-teal-500">{formatCurrency(atsCost)}</td>
                    <td className="px-2 py-2 text-right tabular-nums text-teal-700">{formatCurrency(atsRev)}</td>
                    <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(Math.abs(atsRev), Math.abs(atsCost)))}`}>{formatPct(calcGP(Math.abs(atsRev), Math.abs(atsCost)))}</td>
                  </tr>
                );
              })}
            </tbody>
            {data.length > 0 && (
              <tfoot className="sticky bottom-0 bg-slate-100 border-t-2 border-slate-300">
                <tr className="font-semibold text-slate-700">
                  <td className="px-3 py-2">TOTAL</td>
                  <td className="px-2 py-2 text-right tabular-nums font-bold text-blue-500">{formatCurrency(calcTotals.totalProdCost)}</td>
                  <td className="px-2 py-2 text-right tabular-nums font-bold text-indigo-700">{formatCurrency(calcTotals.totalProdRev)}</td>
                  <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(calcTotals.totalProdRev, calcTotals.totalProdCost))}`}>{formatPct(calcGP(calcTotals.totalProdRev, calcTotals.totalProdCost))}</td>
                  <td className="px-2 py-2 text-right tabular-nums text-green-700">{formatCurrency(calcTotals.invoicedRev)}</td>
                  <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(calcTotals.invoicedRev, calcTotals.invoicedCost))}`}>{formatPct(calcGP(calcTotals.invoicedRev, calcTotals.invoicedCost))}</td>
                  <td className="px-2 py-2 text-right tabular-nums font-bold text-purple-500">{formatCurrency(calcTotals.leftToShipCost)}</td>
                  <td className="px-2 py-2 text-right tabular-nums text-purple-700">{formatCurrency(calcTotals.leftToShipRev)}</td>
                  <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(calcTotals.leftToShipRev, calcTotals.leftToShipCost))}`}>{formatPct(calcGP(calcTotals.leftToShipRev, calcTotals.leftToShipCost))}</td>
                  <td className="px-2 py-2 text-right tabular-nums text-orange-700">{formatCurrency(calcTotals.onPickRev)}</td>
                  <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(calcTotals.onPickRev, calcTotals.onPickCost))}`}>{formatPct(calcGP(calcTotals.onPickRev, calcTotals.onPickCost))}</td>
                  <td className="px-2 py-2 text-right tabular-nums font-bold text-teal-500">{formatCurrency(calcTotals.receivedCost - calcTotals.invoicedCost - calcTotals.onPickCost)}</td>
                  <td className="px-2 py-2 text-right tabular-nums text-teal-700">{formatCurrency(calcTotals.receivedRev - calcTotals.invoicedRev - calcTotals.onPickRev)}</td>
                  <td className={`px-2 py-2 text-right tabular-nums ${gpColorClass(calcGP(Math.abs(calcTotals.receivedRev - calcTotals.invoicedRev - calcTotals.onPickRev), Math.abs(calcTotals.receivedCost - calcTotals.invoicedCost - calcTotals.onPickCost)))}`}>{formatPct(calcGP(Math.abs(calcTotals.receivedRev - calcTotals.invoicedRev - calcTotals.onPickRev), Math.abs(calcTotals.receivedCost - calcTotals.invoicedCost - calcTotals.onPickCost)))}</td>
                </tr>
              </tfoot>
            )}
          </table>
        </div>
      </div>
    );
  };

  // Split customerData into Presold (exclude LINE/Stock) and Open Stock (only LINE/Stock)
  const openStockNames = ['LINE', 'STOCK'];
  const isOpenStock = (name) => openStockNames.includes((name || '').toUpperCase());
  const presoldData = customerData.filter(r => !isOpenStock(r.Customer));
  const openStockData = customerData.filter(r => isOpenStock(r.Customer));

  // Calculate summary totals from customerData (matches the visible table)
  // Then add Transfer totals (sales with no production) - these are NOT in customerData
  const baseSummary = customerData.reduce((acc, row) => ({
    totalProdRev: acc.totalProdRev + (Number(row.Total_Production_Revenue) || 0),
    totalProdCost: acc.totalProdCost + (Number(row.Total_Production_Cost) || 0),
    receivedRev: acc.receivedRev + (Number(row.Received_Revenue) || 0),
    receivedCost: acc.receivedCost + (Number(row.Received_Cost) || 0),
    inTransitRev: acc.inTransitRev + (Number(row.In_Transit_Revenue) || 0),
    inTransitCost: acc.inTransitCost + (Number(row.In_Transit_Cost) || 0),
    wipNotTransitRev: acc.wipNotTransitRev + (Number(row.WIP_Not_In_Transit_Revenue) || 0),
    wipNotTransitCost: acc.wipNotTransitCost + (Number(row.WIP_Not_In_Transit_Cost) || 0),
    wipOtherRev: acc.wipOtherRev + (Number(row.WIP_Other_Revenue) || 0),
    wipOtherCost: acc.wipOtherCost + (Number(row.WIP_Other_Cost) || 0),
    invoicedRev: acc.invoicedRev + (Number(row.Invoiced_Revenue) || 0),
    invoicedCost: acc.invoicedCost + (Number(row.Invoiced_Cost) || 0),
    onPickRev: acc.onPickRev + (Number(row.On_Pick_Revenue) || 0),
    onPickCost: acc.onPickCost + (Number(row.On_Pick_Cost) || 0),
    openConfRev: acc.openConfRev + (Number(row.Open_Confirmed_Revenue) || 0),
    openConfCost: acc.openConfCost + (Number(row.Open_Confirmed_Cost) || 0),
    remainingRev: acc.remainingRev + (Number(row.Remaining_Open_Revenue) || 0),
    remainingCost: acc.remainingCost + (Number(row.Remaining_Open_Cost) || 0),
  }), {
    totalProdRev: 0, totalProdCost: 0, receivedRev: 0, receivedCost: 0,
    inTransitRev: 0, inTransitCost: 0, wipNotTransitRev: 0, wipNotTransitCost: 0,
    wipOtherRev: 0, wipOtherCost: 0,
    invoicedRev: 0, invoicedCost: 0, onPickRev: 0, onPickCost: 0,
    openConfRev: 0, openConfCost: 0, remainingRev: 0, remainingCost: 0
  });

  // Summary matches the By Customer table (no transfer totals added)
  const summaryData = baseSummary;

  // Calculate GP% helper
  const gpColor = (gp) => gp >= 0.3 ? 'text-green-600' : gp < 0 ? 'text-red-600' : 'text-slate-600';
  const summary = {
    ...summaryData,
    totalProdGP: calcGP(summaryData.totalProdRev, summaryData.totalProdCost),
    receivedGP: calcGP(summaryData.receivedRev, summaryData.receivedCost),
    inTransitGP: calcGP(summaryData.inTransitRev, summaryData.inTransitCost),
    atsRev: summaryData.receivedRev - summaryData.invoicedRev - summaryData.onPickRev,
    atsCost: summaryData.receivedCost - summaryData.invoicedCost - summaryData.onPickCost,
    atsGP: calcGP(
      Math.abs(summaryData.receivedRev - summaryData.invoicedRev - summaryData.onPickRev),
      Math.abs(summaryData.receivedCost - summaryData.invoicedCost - summaryData.onPickCost)
    ),
    wipNotTransitGP: calcGP(summaryData.wipNotTransitRev, summaryData.wipNotTransitCost),
    wipOtherGP: calcGP(summaryData.wipOtherRev, summaryData.wipOtherCost),
    invoicedGP: calcGP(summaryData.invoicedRev, summaryData.invoicedCost),
    onPickGP: calcGP(summaryData.onPickRev, summaryData.onPickCost),
    openConfGP: calcGP(summaryData.openConfRev, summaryData.openConfCost),
    remainingGP: calcGP(summaryData.remainingRev, summaryData.remainingCost),
  };

  return (
    <div className="space-y-4">
      {/* Header - Champion SP26 */}
      <div className="bg-indigo-50 border border-indigo-200 rounded-lg px-4 py-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {/* Champion Logo */}
          <svg viewBox="0 65 193 45" className="h-8 w-auto" style={{ minWidth: '120px' }}>
            <g fill="#002244" fillRule="evenodd" clipRule="evenodd">
              {CHAMPION_LOGO_PATHS.map((d, i) => <path key={i} d={d} />)}
            </g>
          </svg>
          <span className="text-sm font-medium text-[#002244]">SP26 Div 10 - Production vs Sales</span>
        </div>
      </div>

      {/* Summary Cards */}
      {!loading && !error && (
        <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
          <h3 className="text-sm font-semibold text-[#003DA5] mb-3">Champion {selectedSeason} Div 10 Summary</h3>
          <div className="grid grid-cols-6 gap-3">
            <div className="bg-indigo-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-indigo-600 font-medium">Total Production</p>
              <p className="text-lg font-bold text-indigo-700">{formatCurrency(summary.totalProdRev)}</p>
              <p className="text-[10px] text-indigo-500">Cost: {formatCurrency(summary.totalProdCost)}</p>
              <p className={`text-xs ${gpColor(summary.totalProdGP)}`}>{formatPct(summary.totalProdGP)} GP</p>
            </div>
            <div className="bg-green-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-green-600 font-medium">Invoice</p>
              <p className="text-lg font-bold text-green-700">{formatCurrency(summary.invoicedRev)}</p>
              <p className="text-[10px] text-green-500">Cost: {formatCurrency(summary.invoicedCost)}</p>
              <p className={`text-xs ${gpColor(summary.invoicedGP)}`}>{formatPct(summary.invoicedGP)} GP</p>
            </div>
            <div className="bg-purple-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-purple-600 font-medium">Left to Ship</p>
              <p className="text-lg font-bold text-purple-700">{formatCurrency(summary.totalProdRev - summary.invoicedRev)}</p>
              <p className="text-[10px] text-purple-500">Cost: {formatCurrency(summary.totalProdCost - summary.invoicedCost)}</p>
              <p className={`text-xs ${gpColor(calcGP(summary.totalProdRev - summary.invoicedRev, summary.totalProdCost - summary.invoicedCost))}`}>{formatPct(calcGP(summary.totalProdRev - summary.invoicedRev, summary.totalProdCost - summary.invoicedCost))} GP</p>
            </div>
            <div className="bg-orange-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-orange-600 font-medium">On Pick</p>
              <p className="text-lg font-bold text-orange-700">{formatCurrency(summary.onPickRev)}</p>
              <p className="text-[10px] text-orange-500">Cost: {formatCurrency(summary.onPickCost)}</p>
              <p className={`text-xs ${gpColor(summary.onPickGP)}`}>{formatPct(summary.onPickGP)} GP</p>
            </div>
            <div className="bg-teal-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-teal-600 font-medium">ATS</p>
              <p className="text-lg font-bold text-teal-700">{formatCurrency(summary.atsRev)}</p>
              <p className="text-[10px] text-teal-500">Cost: {formatCurrency(summary.atsCost)}</p>
              <p className={`text-xs ${gpColor(summary.atsGP)}`}>{formatPct(summary.atsGP)} GP</p>
            </div>
            <div className="bg-amber-50 rounded-lg p-3 text-center">
              <p className="text-[10px] text-amber-600 font-medium">Total WIP</p>
              <p className="text-lg font-bold text-amber-700">{formatCurrency(summary.inTransitRev + summary.wipNotTransitRev)}</p>
              <p className="text-[10px] text-amber-500">Cost: {formatCurrency(summary.inTransitCost + summary.wipNotTransitCost)}</p>
              <p className="text-[9px] text-amber-500 mt-0.5">In Transit: Rev {formatCurrency(summary.inTransitRev)} | Cost {formatCurrency(summary.inTransitCost)}</p>
              <p className="text-[9px] text-amber-500">Open Prod: Rev {formatCurrency(summary.wipNotTransitRev)} | Cost {formatCurrency(summary.wipNotTransitCost)}</p>
            </div>
          </div>
        </div>
      )}

      {/* In Transit by Country of Origin & Prod Type */}
      {!loading && !error && countryOriginData.length > 0 && (() => {
        // Convert 2-letter ISO code to flag emoji
        const toFlag = (code) => {
          if (!code || code.length !== 2) return '';
          return String.fromCodePoint(
            ...[...code.toUpperCase()].map(c => 0x1F1E6 + c.charCodeAt(0) - 65)
          );
        };
        // Group by country, then by prod type within each country
        const byCountry = {};
        countryOriginData.forEach(r => {
          const country = r.CountryOrigin || 'Unknown';
          const type = r.Prod_Type || 'Direct';
          const val = Number(r.In_Transit_Cost) || 0;
          if (val <= 0) return;
          if (!byCountry[country]) byCountry[country] = { total: 0, types: {} };
          byCountry[country].total += val;
          byCountry[country].types[type] = (byCountry[country].types[type] || 0) + val;
        });
        const countries = Object.entries(byCountry)
          .sort((a, b) => b[1].total - a[1].total);
        const maxVal = countries.length > 0 ? countries[0][1].total : 1;
        const totalTransit = countries.reduce((sum, [, d]) => sum + d.total, 0);
        const typeColors = { FOB: 'bg-teal-500', DDP: 'bg-amber-500', Direct: 'bg-indigo-500' };
        if (countries.length === 0) return null;
        return (
          <div className="bg-white rounded-lg border border-slate-200 shadow-sm p-4">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-sm font-semibold text-[#003DA5]">In Transit by Country of Origin (Cost)</h3>
              <div className="flex items-center gap-3">
                {Object.entries(typeColors).map(([type, color]) => (
                  <span key={type} className="flex items-center gap-1">
                    <span className={`inline-block w-2.5 h-2.5 rounded-sm ${color}`} />
                    <span className="text-[10px] text-slate-500 font-medium">{type}</span>
                  </span>
                ))}
                <span className="text-[10px] text-slate-400 ml-1">|</span>
                <span className="text-xs text-indigo-600 font-semibold">{formatCurrency(totalTransit)} total</span>
              </div>
            </div>
            <div className="space-y-1.5">
              {countries.map(([country, data]) => {
                const barWidth = maxVal > 0 ? Math.max((data.total / maxVal) * 100, 2) : 0;
                const pct = totalTransit > 0 ? ((data.total / totalTransit) * 100).toFixed(1) : 0;
                const flag = toFlag(country);
                return (
                  <div key={country} className="flex items-center gap-2">
                    <span className="text-xs text-slate-600 w-24 truncate font-medium flex items-center gap-1">
                      {flag && <span className="text-sm">{flag}</span>}
                      <span>{country}</span>
                    </span>
                    <div className="flex-1 h-5 bg-slate-100 rounded-full overflow-hidden">
                      <div className="h-full flex rounded-full overflow-hidden transition-all duration-500" style={{ width: `${barWidth}%` }}>
                        {['FOB', 'DDP', 'Direct'].map(type => {
                          const typeVal = Number(data.types[type]) || 0;
                          if (typeVal <= 0) return null;
                          const typePct = (typeVal / data.total) * 100;
                          return (
                            <div
                              key={type}
                              className={`h-full ${typeColors[type]} transition-all duration-500`}
                              style={{ width: `${typePct}%` }}
                              title={`${type}: ${formatCurrency(typeVal)}`}
                            />
                          );
                        })}
                      </div>
                    </div>
                    <span className="text-xs text-slate-700 font-semibold w-20 text-right">{formatCurrency(data.total)}</span>
                    <span className="text-[10px] text-slate-400 w-10 text-right">{pct}%</span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })()}

      {/* Filters Card */}
      <div className="bg-white rounded-lg border border-slate-200 shadow-sm">
        <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
          <div className="flex items-center gap-4">
            {/* Exclude All Year Styles Filter */}
            <label className="flex items-center gap-1.5 cursor-pointer">
              <input
                type="checkbox"
                checked={excludeAllYear}
                onChange={(e) => setExcludeAllYear(e.target.checked)}
                className="w-3.5 h-3.5 rounded border-slate-300 text-indigo-600 focus:ring-indigo-500"
              />
              <span className="text-xs font-medium text-slate-600">Exclude All Year Styles</span>
            </label>
          </div>

          <div className="flex items-center gap-2">
            {hasActiveFilters && (
              <button onClick={clearFilters} className="px-2 py-1 text-xs text-red-600 hover:bg-red-50 rounded">
                Reset
              </button>
            )}
            <button onClick={handleExportExcel} className="flex items-center gap-1 px-2.5 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700">
              <Download size={12} /> Excel
            </button>
            <button onClick={handleExportPDF} className="flex items-center gap-1 px-2.5 py-1 text-xs bg-slate-600 text-white rounded hover:bg-slate-700">
              <FileText size={12} /> PDF
            </button>
            <button onClick={fetchData} disabled={loading} className="flex items-center gap-1 px-2.5 py-1 text-xs bg-[#003DA5] text-white rounded hover:bg-[#002d7a] disabled:opacity-50">
              <RefreshCw size={12} className={loading ? 'animate-spin' : ''} />
            </button>
          </div>
        </div>

        {/* Labels Filter - Data-driven from Label groupBy results */}
        <div className="px-4 py-2.5 bg-slate-50/50">
          <div className="flex items-center gap-2 flex-wrap">
            <div className="flex items-center gap-1.5">
              <Filter size={12} className="text-slate-400" />
              <span className="text-xs font-medium text-slate-500">Labels</span>
              <span className="text-[10px] text-slate-400">(click to exclude)</span>
            </div>

            {excludedLabels.length > 0 && (
              <button
                onClick={() => setExcludedLabels([])}
                className="px-1.5 py-0.5 text-[10px] text-red-600 hover:bg-red-50 rounded flex items-center gap-0.5"
              >
                <X size={10} /> Clear excluded
              </button>
            )}

            <div className="flex flex-wrap gap-1 ml-2">
              {availableLabels.map(label => {
                const isExcluded = excludedLabels.includes(label);
                return (
                  <button
                    key={label}
                    onClick={() => toggleLabelExclusion(label)}
                    className={`px-2 py-0.5 text-[10px] rounded-full border transition-all ${
                      isExcluded
                        ? 'bg-red-100 text-red-600 border-red-300 line-through'
                        : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'
                    }`}
                  >
                    {label}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-16 bg-white rounded-lg border border-slate-200">
          <RefreshCw size={20} className="animate-spin text-[#003DA5]" />
          <span className="ml-2 text-sm text-slate-600">Loading Champion Production vs Sales data...</span>
        </div>
      ) : error ? (
        <div className="flex items-center justify-center py-16 bg-white rounded-lg border border-red-200">
          <AlertCircle size={20} className="text-red-500 mr-2" />
          <span className="text-sm text-red-600">{error}</span>
        </div>
      ) : (
        <>
          <DataTable
            title="Presold"
            data={presoldData}
            groupByField="Customer"
            color="purple"
          />
          <DataTable
            title="Open Stock"
            data={openStockData}
            groupByField="Customer"
            color="amber"
          />
        </>
      )}
    </div>
  );
}
